export interface EcosystemAdminScopePickerProps {
  ecosystemOptions: Array<{ id: string; label: string }>;
  selectedEcosystemId: string;
  onSelect: (ecosystemId: string) => void;
}

export default function EcosystemAdminScopePicker({
  ecosystemOptions,
  selectedEcosystemId,
  onSelect,
}: EcosystemAdminScopePickerProps) {
  if (ecosystemOptions.length === 0) {
    return <p className="tree-dashboard-muted">No administerable ecosystems in scope.</p>;
  }

  return (
    <div className="admin-member-form" style={{ marginBottom: '1rem' }}>
      <label className="ecosystem-description" htmlFor="eco-admin-scope">
        Ecosystem in focus
      </label>
      <select
        id="eco-admin-scope"
        value={selectedEcosystemId}
        onChange={(e) => onSelect(e.target.value)}
      >
        {ecosystemOptions.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
